import { useState } from "react";

import { BanManagementModalProps } from "../types/commonTypes";

export const useBanManagementModal = () => {
  const [showBanManagementModal, setShowBanManagementModal] = useState<{
    id: string;
    open: boolean;
    data: any;
  }>({
    id: "",
    open: false,
    data: null,
  });

  const handleBanManagementModal = ({ id, data }: BanManagementModalProps) => {
    setShowBanManagementModal({
      id,
      open: true,
      data,
    });
  };

  return {
    showBanManagementModal,
    setShowBanManagementModal,
    handleBanManagementModal,
  };
};
